import ModelAPIs from './ModelAPIs';

export default ModelAPIs;
